<div class="email-wrapper">
    <div class="head-tag">
        <h4>{{ 'SETTING_PAGE.IDMS_SETTINGS.BATCH_CALCULATION' | transloco }}</h4>
    </div>
    <div class="paginate">
        <div class="row">
            <ng-container *ngIf="StateFormGroup.get('status').value != 'Active'">
                <div class="col-md-3" *ngIf="batchList?.length">
                    <p style="max-width: 200px; float: left; color: #b5b5c3" class="PageDetails">
                        Page <b>{{ batchPage }}</b> of <b>{{ itemsPerPage }}</b> (<b>{{ totalBatchCount }}</b>
                        items)
                    </p>
                </div>
                <div class="col-md-7">
                    <pagination-controls
                        *ngIf="batchList?.length"
                        (pageChange)="onBatchPageChange($event)"
                        id="batch-pagination"
                        maxSize="9"
                        directionLinks="true"
                        responsive="true"
                        screenReaderPaginationLabel="Batch Pagination"
                        screenReaderPageLabel="page"
                        screenReaderCurrentLabel="You're on page"
                        style="max-width: 700px; float: right; position: relative; margin-right: 19px"
                        previousLabel=""
                        nextLabel=""
                        [page]="batchPage"
                        [totalItems]="totalBatchCount"
                        [itemsPerPage]="itemsPerPage"
                        class="numbering-pagination-wrap"
                    ></pagination-controls>
                </div>
            </ng-container>
            <div [ngClass]="StateFormGroup.get('status').value != 'Active' ? 'col-md-2' : 'col-md-12'">
                <form [formGroup]="StateFormGroup" class="d-flex justify-content-end w-100 mb-4">
                    <div class="btn-group custom-toggle-wrap" role="group">
                        <label *ngFor="let opt of stateOptions" class="btn custom-toggle" [class.active]="opt.value === StateFormGroup.get('status')?.value">
                            <input type="radio" class="btn-check" [value]="opt.value" [formControl]="StateFormGroup.get('status')" autocomplete="off" />
                            {{ opt.label }}
                        </label>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <div class="w-100" style="padding: 23px 30px; padding-top: 0px">
                <ng-cointainer *ngIf="!batchList?.length && StateFormGroup.get('status').value == 'Active'">
                    <div class="no-data-wrapper w-100">
                        <h1 class="no-data-message">
                            {{ 'SETTING_PAGE.IDMS_SETTINGS.NO_ACTIVE_BATCH_CALCULATIONS' | transloco }}
                        </h1>
                    </div>
                </ng-cointainer>
                <mat-accordion multi="false" class="informate-expansion-wrapper informate-matrix-expansion-wrapper" *ngIf="batchList?.length">
                    <ng-container
                        *ngFor="
                            let batch of batchList
                                | paginate: { itemsPerPage: itemsPerPage, currentPage: batchPage, totalItems: totalBatchCount, id: 'batch-pagination' }
                        "
                    >
                        <!-- (opened)="showPanel(batch.batchId)" -->
                        <mat-expansion-panel [disabled]="true" [expanded]="false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Batch
                                    {{
                                        batch.statusIndex == '10'
                                            ? 'Queued'
                                            : batch.statusIndex == '100'
                                              ? 'Started'
                                              : batch.statusIndex == '200'
                                                ? 'Completed'
                                                : ''
                                    }}
                                    at
                                    {{
                                        batch.statusIndex == '10'
                                            ? (batch.queuedDate | date: 'dd/MM/yyyy HH:mm:ss')
                                            : batch.statusIndex == '100'
                                              ? (batch.startDate | date: 'dd/MM/yyyy HH:mm:ss')
                                              : batch.statusIndex == '200'
                                                ? (batch.calculatedDate | date: 'dd/MM/yyyy HH:mm:ss')
                                                : ''
                                    }}
                                    by {{ batch.createdBy }} | ({{ batch.countCalculated }} calculated out of {{ batch.countTotal }})
                                </mat-panel-title>
                                <!-- *ngIf="batch.fileOutput" -->
                                <a
                                    *ngIf="StateFormGroup.get('status').value == 'Completed'"
                                    href="javascript:void(0)"
                                    #tooltip="matTooltip"
                                    matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.DOWNLOAD' | transloco }}"
                                    [matTooltipPosition]="tooltip_position"
                                    class="mr-5"
                                    (click)="DownloadFiles(batch)"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        width="24px"
                                        height="24px"
                                        viewBox="0 0 24 24"
                                        version="1.1"
                                    >
                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <rect x="0" y="0" width="24" height="24" />
                                            <rect
                                                fill="#000000"
                                                opacity="0.3"
                                                transform="translate(12.000000, 7.000000) rotate(-180.000000) translate(-12.000000, -7.000000) "
                                                x="11"
                                                y="1"
                                                width="2"
                                                height="12"
                                                rx="1"
                                            />
                                            <path
                                                d="M17,8 C16.4477153,8 16,7.55228475 16,7 C16,6.44771525 16.4477153,6 17,6 L18,6 C20.209139,6 22,7.790861 22,10 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 L2,9.99305689 C2,7.7839179 3.790861,5.99305689 6,5.99305689 L7.00000482,5.99305689 C7.55228957,5.99305689 8.00000482,6.44077214 8.00000482,6.99305689 C8.00000482,7.54534164 7.55228957,7.99305689 7.00000482,7.99305689 L6,7.99305689 C4.8954305,7.99305689 4,8.88848739 4,9.99305689 L4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,10 C20,8.8954305 19.1045695,8 18,8 L17,8 Z"
                                                fill="#000000"
                                                fill-rule="nonzero"
                                                opacity="0.3"
                                            />
                                            <path
                                                d="M14.2928932,10.2928932 C14.6834175,9.90236893 15.3165825,9.90236893 15.7071068,10.2928932 C16.0976311,10.6834175 16.0976311,11.3165825 15.7071068,11.7071068 L12.7071068,14.7071068 C12.3165825,15.0976311 11.6834175,15.0976311 11.2928932,14.7071068 L8.29289322,11.7071068 C7.90236893,11.3165825 7.90236893,10.6834175 8.29289322,10.2928932 C8.68341751,9.90236893 9.31658249,9.90236893 9.70710678,10.2928932 L12,12.5857864 L14.2928932,10.2928932 Z"
                                                fill="#000000"
                                                fill-rule="nonzero"
                                            />
                                        </g>
                                    </svg>
                                </a>
                            </mat-expansion-panel-header>

                            <!-- <mat-panel-description class="panel-description">
                                <h3 class="warning-title">Warning and Error Messages</h3>
                                <div class="d-flex justify-content-center" *ngIf="spinerDisplay">
                                    <div class="spinner-border" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>

                                <ng-container *ngIf="!spinerDisplay">
                                    <div class="row w-100" *ngIf="queuedItemErrors?.length">
                                        <div class="col-md-4">
                                            <p style="max-width: 200px; float: left; color: #b5b5c3" class="PageDetails">
                                                Page <b>{{ queuedPage }}</b> of <b>{{ queuedItemsPerPage }}</b> (<b>{{ totalQueuedCount }}</b> items)
                                            </p>
                                        </div>
                                        <div class="col-md-8">
                                            <pagination-controls
                                                (pageChange)="onQueuedPageChange($event)"
                                                id="queued-pagination"
                                                maxSize="9"
                                                directionLinks="true"
                                                responsive="true"
                                                screenReaderPaginationLabel="Queued Items Pagination"
                                                screenReaderPageLabel="page"
                                                screenReaderCurrentLabel="You're on page"
                                                style="max-width: 700px; float: right; position: relative; margin-right: 19px"
                                                previousLabel=""
                                                nextLabel=""
                                                [page]="queuedPage"
                                                [totalItems]="totalQueuedCount"
                                                [itemsPerPage]="queuedItemsPerPage"
                                                class="numbering-pagination-wrap"
                                            ></pagination-controls>
                                        </div>
                                    </div>
                                    <div class="table_responsive w-100">
                                        <table class="mat-table div-wrapper mat-table-wrapper">
                                            <thead>
                                                <tr class="mat-header-row">
                                                    <th class="mat-header-cell">Date</th>
                                                    <th class="mat-header-cell">Tagged Item Name</th>
                                                    <th class="mat-header-cell">Message</th>
                                                    <th class="mat-header-cell">Severity</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container *ngIf="!queuedItemErrors?.length">
                                                    <tr class="mat-header-row">
                                                        <td class="error-message mat-cell" colspan="4">No Warnings and Error found.</td>
                                                    </tr>
                                                </ng-container>
                                                <ng-container *ngIf="queuedItemErrors?.length">
                                                    <tr
                                                        class="mat-row"
                                                        *ngFor="
                                                            let qError of queuedItemErrors
                                                                | paginate
                                                                    : {
                                                                          itemsPerPage: queuedItemsPerPage,
                                                                          currentPage: queuedPage,
                                                                          totalItems: totalQueuedCount,
                                                                          id: 'queued-pagination',
                                                                      }
                                                        "
                                                    >
                                                        <td class="mat-cell">{{ qError.date | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                                        <td class="mat-cell">{{ qError.taggedItem }}</td>
                                                        <td class="mat-cell">{{ qError.error }}</td>
                                                        <td class="mat-cell">
                                                            {{
                                                                qError.severity == 1
                                                                    ? 'Critical'
                                                                    : qError.severity == 2
                                                                      ? 'Warning'
                                                                      : qError.severity == 3
                                                                        ? 'Information'
                                                                        : ''
                                                            }}
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                            </tbody>
                                        </table>
                                    </div>
                                </ng-container>
                            </mat-panel-description> -->
                        </mat-expansion-panel>
                    </ng-container>
                </mat-accordion>
            </div>
        </div>
    </div>
</div>
